<template>
  <div
    :class="`substep ${substep.color}`"
    :style="`
      top: calc(100% * ${(substep.start - working_time_start) / working_time_duration} + 1px);
      height: calc(100% * ${substep.duration / working_time_duration} - 2px);
      width: calc(100% * ${substep.width} - 2px);
      left: calc((100% / ${max_x_index + 1}) * ${substep.x_index} + 1px);
      ${selected?'outline: 2px solid white;':''}
      ${moving?'opacity: 0.3;':''}
    `"
    @mousedown="$emit('mousedownBody')"
  >
    <div 
      v-if="show_length_handler"
      class="substep-handler handler-top"
      @mousedown.prevent.stop="$emit('mousedownHandlerTop')"

    />
    <div 
      v-if="show_length_handler"
      class="substep-handler handler-bottom"
      @mousedown.prevent.stop="$emit('mousedownHandlerBottom')"
    />
    <div class="substep-header">
      <TText
        :text="substep.start_time_string"
        :color="substep.textcolor"
        :size="12"
      />
      <div class="d-flex">
        <TIcon
          :name="getNewIcon(substep.icon)"
          :color="substep.textcolor"
          size="20"
        />
        <TText
          :text="substep.token"
          :color="substep.textcolor"
          :size="12"
          :font_weight="500"
        />
      </div>
      <TText
        v-if="substep.width === 1"
        :text="substep.taktarea_name"
        :color="substep.textcolor"
        :size="12"
        font_weight="200"
        max_lines="1"
        style="flex-grow: 1;"
      />
      <TIcon
        v-if="substep.step_icon"
        :name="substep.step_icon"
        :color="substep.textcolor"
        size="20"
      />
      </div>
      <TText
        v-if="substep.width < 1"
        :text="substep.taktarea_name"
        :color="substep.textcolor"
        :size="12"
        font_weight="200"
        max_lines="1"
        style="flex-grow: 1;"
      />
      <div class="substep-body">
        <TText
          :text="substep.step_text"
          :color="substep.textcolor"
          :size="10"
        />
        <TText
          :text="substep.end_time_string"
          :color="substep.textcolor"
          :size="12"
        />
      </div>
  </div>
</template>
  <script>
    import { mapGetters, /* mapActions, */ } from 'vuex';
    import TIcon from '@/components/Taktify/TIcon.component.vue';
    import TText from '@/components/Taktify/TText.component.vue';

    export default {
      props: [
        'substep', 
        'working_time_start', 
        'working_time_duration', 
        'max_x_index', 
        'selected', 
        'show_length_handler', 
        'moving',
      ],

      components: {
        TIcon,
        TText,
      },

      data: () => ({

      }),

      computed: {
      ...mapGetters('WorkPackage', [
        'getNewIcon'
        ],
      ),
      }
    }
  </script>
  <style>
    .substep {
        display: flex;
        flex-direction: column;
        position: absolute;
        border-radius: 5px;
        overflow: hidden;
        user-select: none;
        opacity: 0.95;
        z-index: 10;
    }
    .substep-header {
        display: flex;
        width: 100%;
        grid-gap: 4px;
    }
    .substep-body {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    .substep-text {
        display: flex;
    }
    .substep-handler {
        position: absolute;
        width: 100%;
        height: 10px;
        /* background-color: red; */
        cursor: row-resize;
        z-index: 10;
    }
    .handler-top {
        top: 0px;
    }
    .handler-bottom {
        bottom: 0px;
    }
  </style>
  